import {BearService} from './bear.service';

export const BearInjectables: Array<any> = [
  {
    provide: BearService,
    useClass: BearService,
  },
];
